import React, { Component } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import LinearProgress from "@material-ui/core/LinearProgress";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import withStyles from "@material-ui/styles/withStyles";
import _ from "lodash";

import shootService from "../../../../services/shootService";

import StarIcon from "@material-ui/icons/Star";
import StarBorderIcon from "@material-ui/icons/StarBorder";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as dialogActions from "../../../../redux/actions/dialogactions";
import * as shootActions from "../../../../redux/actions/shootsactions";
import { computeShotStatusColor, shotStatusColor } from "../../../../utils/colorUtils";

const styles = theme => ({
  warningButton: {
    color: "#f1c40f",
    borderColor: "#f1c40f",
    "&:hover": {
      backgroundColor: "rgba(241, 196, 15,0.1)",
      borderColor: "#f1c40f",
      boxShadow: "none"
    }
  }
});

class PackageTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fetching: true,
      fetched: false,
      failed: false,
      shots: [],
      selectedRow: null,
      selectedMenu: null,
      selected: [],
      orderBy: "priority",
      order: "asc",
      filterstate: ""
    };
  }

  componentDidMount() {
    this.getShots();
  }

  getShots = async () => {
    try {
      if (!this.state.fetching) this.setState({ fetching: true });
      let { date, name } = this.props.match.params;
      let { data } = await shootService.getOneShootPackageShots({
        clinic: name,
        created_at: date,
        id: this.props.data.id
      });
      console.log(data);
      this.setState({ fetching: false, failed: false, fetched: true, shots: data });
    } catch (err) {
      console.log(err);
      this.setState({ fetching: false, failed: true, fetched: true });
    }
  };

  initiateDeletePackage = () => {
    this.props.dialogActions.openConfirmDialog(
      "Are you sure?",
      `You are about remove this package from the shoot. This action is irreversable, are you sure you want to proceed?`,
      "PACKAGE_REMOVE" + this.props.data.id
    );
  };

  componentDidUpdate(prevProps) {
    if (this.props.confirmDialog === false && prevProps.confirmDialog === true) {
      console.log("confirm model closed!: " + this.props.confirmAction);
      if (this.props.confirmChoice) {
        switch (this.props.confirmAction) {
          case "PACKAGE_REMOVE" + this.props.data.id:
            this.deletePackage();
            break;
          default:
            break;
        }
      }
    }
  }

  deletePackage = async () => {
    try {
      console.log("delete");
      if (!this.state.fethcing) this.setState({ fetching: true });
      let { date, name } = this.props.match.params;
      let { id } = this.props.data;
      await shootService.deleteOnePackageFromShoot({
        clinic: name,
        created_at: date,
        id
      });
      this.props.shootActions.getShootPackage(name, date, "photo");
    } catch (err) {
      console.log(err);
    }
  };

  createSortHandler = property => {
    console.log("sort", property);
    this.handleRequestSort(property);
  };
  handleRequestSort = property => {
    const isDesc = this.state.orderBy === property && this.state.order === "desc";
    this.setState({ order: isDesc ? "asc" : "desc" });
    this.setState({ orderBy: property });
  };

  stableSort = (array, cmp) => {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = cmp(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
  };

  getSorting = (order, orderBy) => {
    return order === "desc" ? (a, b) => this.desc(a, b, orderBy) : (a, b) => -this.desc(a, b, orderBy);
  };

  desc = (a, b, orderBy) => {
    if (orderBy === "status") {
      if (a.completed !== b.completed) {
        return a.completed ? -1 : 1;
      } else if (a.undoable !== b.undoable) {
        return a.undoable ? -1 : 1;
      } else return 0;
    } else if (typeof a[orderBy] === "boolean") {
      if (a[orderBy] === b[orderBy]) {
        return b.scene === a.scene ? 0 : b.scene < a.scene ? -1 : 1;
      }
      return a[orderBy] ? 1 : -1;
    } else {
      if (b[orderBy] < a[orderBy]) {
        return -1;
      }
      if (b[orderBy] > a[orderBy]) {
        return 1;
      }
      return 0;
    }
  };

  render() {
    let { data, classes, status } = this.props;
    let { shots } = this.state;
    const { orderBy, order, filterstate } = this.state;

    let photoList = this.stableSort(shots, this.getSorting(order, orderBy)).map(shot => (
      <TableRow key={shot.shot_id}>
        <TableCell>{shot.priority ? <StarIcon color="primary" /> : <StarBorderIcon color="primary" />}</TableCell>
        <TableCell>{shot.scene}</TableCell>
        <TableCell
          style={
            this.props.status !== "DRAFT"
              ? this.props.type === "video"
                ? { width: "30%" }
                : { width: "35%" }
              : this.props.type === "video"
              ? { width: "30%" }
              : { width: "40%" }
          }
        >
          {shot.description}
        </TableCell>
        <TableCell>{shot.location}</TableCell>
        <TableCell>{shot.angle}</TableCell>
        <TableCell>{shot.framing}</TableCell>
        {this.props.type === "video" && <TableCell>{shot.framing}</TableCell>}
        {this.props.status !== "DRAFT" && (
          <TableCell>
            <div style={_.assign({}, this.cellStyle, shotStatusColor(shot.completed ? "COMPLETED" : shot.undoable ? "UNDOABLE" : "PENDING"))}>
              {shot.completed ? "COMPLETED" : shot.undoable ? "UNDOABLE" : "PENDING"}
            </div>
          </TableCell>
        )}
      </TableRow>
    ));

    let { date, name } = this.props.match.params;
    const headCells = [
      { id: "priority", numeric: false, disablePadding: false, label: "Priority" },
      { id: "scene", numeric: false, disablePadding: false, label: "Scene" },
      { id: "description", numeric: false, disablePadding: false, label: "Description" },
      { id: "location", numeric: false, disablePadding: false, label: "Location" },
      { id: "angle", numeric: false, disablePadding: false, label: "Angle" },
      { id: "framing", numeric: false, disablePadding: false, label: "Framing" }
    ];

    if (this.props.type == "video") {
      headCells.push({ id: "camera", numeric: false, disablePadding: false, label: "Camera" });
    }
    if (this.props.status !== "DRAFT") {
      headCells.push({ id: "status", numeric: false, disablePadding: false, label: "Status" });
    }
    return (
      <div style={{ marginBottom: 30 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "0 20px" }}>
          <div style={{ paddingBottom: 30 }}>
            <Typography variant="h5" gutterBottom>
              {data.title}
            </Typography>
            <Typography variant="subtitle2" style={{ paddingLeft: 50 }}>
              {data.description}
            </Typography>
          </div>
          {status === "DRAFT" && (
            <div style={{ paddingLeft: 50 }}>
              <Button
                onClick={this.initiateDeletePackage}
                className={classes.warningButton}
                style={{ marginRight: 5 }}
                variant="outlined"
                color="primary"
                disabled={this.state.fetching}
              >
                Delete
              </Button>
              <Button
                style={{ marginLeft: 5 }}
                variant="outlined"
                color="primary"
                onClick={() => this.props.history.push(`/shoots/edit/${name}/${date}/package/${data.id}`)}
                disabled={this.state.fetching}
              >
                Edit
              </Button>
            </div>
          )}
        </div>
        {this.state.fetching && (
          <div style={{ textAlign: "center", width: "100%" }}>
            <LinearProgress style={{ height: 2 }} />
          </div>
        )}
        <Table>
          <TableHead>
            <TableRow>
              {headCells.map((row, key) => (
                <TableCell
                  key={key}
                  align={row.numeric ? "right" : "left"}
                  padding={row.disablePadding ? "none" : "default"}
                  sortDirection={orderBy === row.id ? order : false}
                  onClick={row.id == "" ? null : () => this.createSortHandler(row.id)}
                  style={row.id == "" ? { width: row.width } : { cursor: "pointer", width: row.width }}
                >
                  {this.state.orderBy === row.id ? (
                    <TableSortLabel active={orderBy === row.id} direction={order}>
                      {row.label}
                    </TableSortLabel>
                  ) : (
                    row.label
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>{this.state.shots.length > 0 && photoList}</TableBody>
        </Table>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    confirmDialog: state.dialog.confirm.open,
    confirmAction: state.dialog.confirm.action,
    confirmChoice: state.dialog.confirm.confirmed,
    status: state.selectedShoot.status
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dialogActions: bindActionCreators(dialogActions, dispatch),
    shootActions: bindActionCreators(shootActions, dispatch)
  };
};

const StylesPackageTab = withStyles(styles)(PackageTable);

export default connect(mapStateToProps, mapDispatchToProps)(StylesPackageTab);
